import { ReactNode } from 'react';
import { FormattedMessage, FormattedNumber } from 'dibs-react-intl';

export const getShippingPrice = ({
    convertedAmountList = [],
    currency,
}: {
    readonly convertedAmountList: ReadonlyArray<{
        readonly currency: string | null;
        readonly amount: number | null;
    } | null> | null;
    currency: string;
}): ReactNode => {
    const { amount } = convertedAmountList?.find(p => p?.currency === currency) || {};

    let price = (
        <FormattedNumber
            value={amount || 0}
            style="currency"
            currency={currency}
            minimumFractionDigits={parseFloat(amount?.toString() || '') % 1 === 0 ? 0 : 2}
        />
    );

    if (amount === 0) {
        price = <FormattedMessage id="shippingHelpers.complimentary" defaultMessage="Free" />;
    }
    return price;
};
